var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M375,334.2c-2,0-4,0-6,0.3c-2.7,0.4-1.9,3.9-1.8,5.9c0,1.7-0.4,4.4,1.4,5.3c1.8,1,5.2,0.5,7.2,0.7 c9.8,1,18.7,0.6,27.5,3.2c2,0.6,4,1.4,5.9,2.4c1.3,0.7,5.1,3.6,6.6,3.2c3.3-0.7-5.2-8.9-6.5-10.1c-7.6-6.8-16.4-9.7-26.4-10.6 C380.3,334.3,377.6,334.3,375,334.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M346.4,335.3c2,0,4-0.1,6,0.1c2.8,0.3,2,3.8,2,5.8c0,1.7,0.6,4.4-1.2,5.4c-1.8,1-5.2,0.6-7.2,0.9 c-9.7,1.3-18.7,1.3-27.4,4.1c-2,0.7-4,1.5-5.8,2.5c-1.3,0.7-5,3.7-6.5,3.5c-3.3-0.6,4.9-9.1,6.1-10.3c7.3-7,16.1-10.2,26-11.5 C341.1,335.6,343.7,335.5,346.4,335.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M334.8,422.5L334.8,422.5L334.8,422.5C334.7,422.6,334.7,422.6,334.8,422.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M397.4,388c-4.8,2.6-10.3,3.9-15.5,4.7c-5.8,0.9-14.1-1.1-19.7-1.5c-6.1-0.4-9.7,0.5-15.4,1.8 c-5.5,1.3-10.2,2.5-15.9,0.9c-5-1.4-9.6-3.5-14.5-5.6c-4-1.7-7.9-3.4-11.5-5.6c3.4,3.5,5.1,8.3,8.2,12c3.4,4,7.1,7,10.1,11.4 c2.2,3.3,4.9,6,4.6,10.4c2.5-2.9,3.5-5,3.1-8.8c2.9,2.7,5.1,11.1,3.8,14.9c3.5-1.9,6-4.4,7.4-8c0.7,3.9,0,9.4-2.9,12.5 c3.9-0.9,9.3-3.7,11.2-7.7c0.9,6.6,2.3,10.3,8.4,14.1c4-4,8.7-6.8,11.1-12.6c0.8,3.4,1.3,6.6,4.7,8.4c-0.6-4.5,0.6-10.7,1.8-15 c0.2,3.3,1.3,6.5,3.8,8.8c1.2-4.6,5.5-9.2,8.7-12.8c3.5-3.9,6.6-8,10.2-11.9c2.6-2.8,5-5.8,7.3-8.8c1.5-1.9,4.6-5.6,5.5-7.1 C405.1,383.9,402.1,385.4,397.4,388z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard5A);
export default __webpack_public_path__ + "static/media/man_beard_5a.42e549d5b377757ef7f272768e37752a.svg";
export { ForwardRef as ReactComponent };